import React from 'react';
import { View } from 'react-native';
import { rem } from 'design-system';
import Amount from 'design-system/Amount';
import StatusIcon from 'design-system/StatusIcon';
import Text from 'design-system/Text';
import { Avatar } from 'design-system/avatar';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { formatDateForItem } from 'utils';
import createStyleSheets from 'utils/createStyleSheets';
const ReferralsListItem = ({ item }) => {
    const date = item.status === 'COMPLETED' ? item.completedAt : item.signedUpAt;
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<View style={styles.rowInner}>
      <View style={styles.rowContent}>
        <Avatar name={item.firstName} lastName={item.lastName} size={44} color={colors.background.brandLight} fontColor={colors.text.brand} primary borderWidth={1} style={styles.avatar}/>
        <View style={styles.rowText}>
          <Text Text-16>
            {item.firstName ? `${item.firstName} ` : ''}
            {item.lastName || ''}
          </Text>
          <View style={styles.rowStatus}>
            <StatusIcon state={item.status === 'COMPLETED' ? 'done' : 'in-progress'}/>
            <Text TextThin-14 Secondary style={styles.rowStatusDate}>
              {date ? formatDateForItem(date) : null}
            </Text>
          </View>
        </View>
      </View>
      <Amount Numbers-16 {...(item.status === 'COMPLETED'
        ? { Blue: true }
        : { Secondary: true })} showSign value={item.getCreditAmount}/>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    row: {
        backgroundColor: colors.cards.onDark,
    },
    rowInner: {
        flexDirection: 'row',
        padding: rem(16),
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    rowContent: {
        flexDirection: 'row',
    },
    rowText: {
        marginLeft: rem(16),
    },
    rowStatus: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    rowStatusDate: {
        marginLeft: rem(8),
    },
    avatar: {
        borderColor: colors.borders.iconStroke,
    },
    card: {
        backgroundColor: colors.cards.onDark,
    },
}));
export default ReferralsListItem;
